import domtoimage from 'dom-to-image';
import { saveAs } from 'file-saver';
import { Button, Flex } from "antd";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFileImage } from '@fortawesome/pro-light-svg-icons';
import { useTranslation } from 'react-i18next';
import { effectiveBackgroundColor, effectiveTextColor, watermarkDataUri } from 'utils/exportImage';

const generateImage = () => {
    const node = document.querySelector('#MainRadar') as HTMLElement;
    if (!node) return;

    // Couleurs du thème actif, telles qu'affichées à l'écran.
    const background = effectiveBackgroundColor(node);
    const textColor = effectiveTextColor(node);

    const calculatedHeight = node.clientHeight * 2 + 30

    domtoimage.toBlob(node, {
        bgcolor: background,
        height: calculatedHeight,
        width: node.clientWidth * 2 * 1.1,
        quality: 1,
        filter: (node) => {
            if (!node.className || !node.className.match)
                return true;

            // Avoid classnames containing['ActionButton', 'ant-btn']
            return !node.className.match('ActionsWrapper') && !node.className.match('ant-btn');
        },
        style: {
            transform: "scale(" + 2 + ")",
            marginTop: "0px",
            transformOrigin: `-10% 0%`,

            height: calculatedHeight * 1.2,
            width: node.clientWidth * 2 * 1.1,

            backgroundColor: background,
            backgroundImage: watermarkDataUri(textColor),
            backgroundRepeat: 'no-repeat',
            backgroundSize: '167.5px 167.5px',
            backgroundPositionX: `0px`,
            backgroundPositionY: `${calculatedHeight / 2 - 90}px`,
        }
    })
        .then(function (blob) {
            // Current date
            saveAs(blob, `Gerositus-${new Date().toLocaleDateString().replace(/\//g, '-') + '-' +
                new Date().toLocaleTimeString().replace(/:/g, '-')
                }.png`);
        });
}

export const ExportTab = (props: any) => {

    const { t } = useTranslation();

    return (

        <Flex vertical className="mt-05">
            <Button variant="text" onClick={() => generateImage()}>
                <FontAwesomeIcon icon={faFileImage} />
                {t("pages.navigator.tabs.export.image")}
            </Button>
        </Flex>
    );
}